import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const images = [
  "/polytechnic/polytechnic1.jpg",
  "/polytechnic/polytechnic2.jpg",
  "/polytechnic/polytechnic3.jpg",
  "/polytechnic/polytechnic4.jpg",
  "/polytechnic/polytechnic5.jpg",
  "/polytechnic/polytechnic6.jpg",
];

const PolytechnicSlideshowBackground: React.FC<{ interval?: number }> = ({ interval = 4000 }) => {
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, interval);
    return () => clearInterval(timer);
  }, [interval]);

  return (
    <div className="absolute inset-0 w-full h-full z-0">
      <AnimatePresence initial={false}>
        <motion.img
          key={images[index]}
          src={images[index]}
          alt={`Polytechnic College Slide ${index + 1}`}
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 1 }}
          className="w-full h-full object-cover absolute inset-0"
        />
      </AnimatePresence>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/60" />
    </div>
  );
};

export default PolytechnicSlideshowBackground;
